// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3n8FW","clinicsSelect":"TableHeading_clinicsSelect__3lN8q"};